import { useState, useMemo, useRef, useEffect } from 'preact/hooks'
import { getLocalAgeVerification, setLocalAgeVerification } from 'helpers/cart'
import CartShipping from 'snippets/cart-shipping/cart-shipping'
import CartCheckout from 'snippets/cart-checkout/cart-checkout'
import CartTotal from 'snippets/cart-total/cart-total'
import CartAgeConfirm from 'snippets/cart-age-confirm/cart-age-confirm'
import CartError from 'snippets/cart-error/cart-error'
import CartMinimum from '../cart-minimum/cart-minimum'
import { getHeight, on } from 'helpers/dom'

function MiniCartButton({ cart, fetching, hasAgeVerification, isPreOrderError, isStoreOnlyError, isInStoreOnlyError, isPralineBoxMixedLocationsError, isMixedCartError }) {
  const [ageVerify, setAgeVerify] = useState(getLocalAgeVerification())

  const isAgeVerify = useMemo(() => {
    setLocalAgeVerification(ageVerify)
    return ageVerify === true
  }, [ageVerify])

  const elRef = useRef(null)

  const cartMinimumSettings = window.SLS_STATE.cart.minimum
  const isNotEnoughMinimum = !cartMinimumSettings.enable || cart.total_price < (cartMinimumSettings.amount * 100)
  const isHoldAccount = window.SLS_STATE.customer?.isHoldAccount
  const isHoldCredit = window.SLS_STATE.customer?.isHoldCredit

  useEffect(() => {
    document.documentElement.style.setProperty('--height-mini-cart-button', getHeight(elRef.current) + 'px')
    on('resize', () => {
      document.documentElement.style.setProperty('--height-mini-cart-button', getHeight(elRef.current) + 'px')
    }, window)
  }, [])

  return (
    <div className="absolute bottom-0 left-0 right-0 z-10 bg-white" ref={elRef}>
      <CartMinimum text={cartMinimumSettings.text} minimumAmount={cartMinimumSettings.amount} />
      <div className="p-4 md:pt-5 md:px-6 md:pb-6">
        <CartTotal price={cart.total_price} fetching={fetching} />
        {hasAgeVerification && (
          <CartAgeConfirm id="age-vetification" className="py-5 border-t" label="I am over 18 years old" onSelect={setAgeVerify} isChecked={ageVerify} value={ageVerify} />
        )}
        <CartCheckout type="mini-cart" className="flex gap-4" disabled={(!isAgeVerify && hasAgeVerification) || isPreOrderError || isStoreOnlyError || isPralineBoxMixedLocationsError || isMixedCartError || isNotEnoughMinimum || isHoldAccount || isHoldCredit } />
        <CartError isPreOrderError={isPreOrderError} isStoreOnlyError={isStoreOnlyError} isInStoreOnlyError={isInStoreOnlyError} isPralineBoxMixedLocationsError={isPralineBoxMixedLocationsError} isMixedCartError={isMixedCartError} isNotEnoughMinimum={isNotEnoughMinimum} isHoldAccount={isHoldAccount} isHoldCredit={isHoldCredit} />
      </div>
    </div>
  )
}

export default MiniCartButton
